module.exports = __webpack_public_path__ + "static/img/study_btn_top.bef722a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/study_btn_top.jpg
// module id = reLz
// module chunks = 12